import { Record } from 'immutable';
import { schema } from 'normalizr';

export const DailySolarReport = new Record({
  id: undefined,
  consumed: undefined,
  generated: undefined,
  corrected: undefined,
  date: undefined,
  site: undefined,
});

export const dailySolarReportSchema = new schema.Entity('dailySolarReports');

// for reading in nested models, object with { field: schema }
// dailySolarReportSchema.define({  });
